export default __webpack_public_path__ + "static/media/Emotions_08.e8ace68e.png";